export default {
  'editorial-staff': 'Vår redaktion',
  'published-on': 'Publicerad den',
  'read-articles': 'Läs hans/hennes artiklar',
  'about-author': 'Om författaren',
}
